import type { Scene } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { isWatermarkAsset } from 'js/src/agent/video-state/serialization/mediaHelpers';

/**
 * Whether the scene shows anything a graphic could be layered over: footage, a speaker, a stock
 * design. A watermark and stickers sit on top of whatever the scene shows, so they don't count, nor
 * does a graphic already on it.
 */
export function showsContentBeneathGraphic(scene: Scene): boolean {
    const graphics = new Set<unknown>(scene.getAssetsByType(VideoData.HTML_ASSET_TYPE));
    return scene
        .getAssets()
        .some(
            (asset) =>
                !graphics.has(asset) &&
                !isWatermarkAsset(asset) &&
                !VideoData.isStickerAsset(asset),
        );
}

/**
 * Whether the scene's graphic is layered over other content rather than owning the frame. Derived
 * from what the scene holds rather than stored, so a graphic is judged the same however it is
 * reopened: by a later edit, a copy, an undo, or the design pane.
 */
export function isLayeredGraphicScene(scene: Scene): boolean {
    return (
        scene.getAssetsByType(VideoData.HTML_ASSET_TYPE).length > 0 &&
        showsContentBeneathGraphic(scene)
    );
}
